<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading" class="mb-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Cadastro de Stands</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="mr-2"
            color="primary lighten-3"
            @click="
              $router.push('/rodadas/' + $route.params.rodada_id + '/stands')
            "
            :disabled="salvando"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-4"
            :disabled="!form_valid"
            @click="salvar"
            :loading="salvando"
            >Salvar</v-btn
          >
        </v-app-bar>

        <v-form ref="form" v-model="form_valid" lazy-validation>
          <v-container fluid v-show="!loading">
            <v-row dense>
              <v-col cols="12" sm="6" class="pa-3">
                <v-text-field
                  label="Nome *"
                  ref="nome"
                  autofocus
                  v-model="stand.nome"
                  :rules="regras.nome"
                  @input="(value) => (stand.nome = value.toUpperCase())"
                  @keypress.native.enter="$refs.valor.focus()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pa-3">
                <as-campo-valor
                  label="Valor *"
                  ref="valor"
                  v-model="stand.valor"
                  :rules="regras.valor"
                  @keypress.native.enter="$refs.proprietario_tipo.focus()"
                ></as-campo-valor>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" sm="6" class="pa-3">
                <v-autocomplete
                  v-model="stand.proprietario_tipo"
                  @change="carregarParticipantes"
                  ref="proprietario_tipo"
                  :items="proprietarios_tipo"
                  label="Tipo de Proprietário"
                  clearable
                  @keypress.native.enter="$refs.proprietario.focus()"
                />
              </v-col>
              <v-col cols="12" sm="6" class="pa-3" v-if="!proprietario_avulso">
                <v-autocomplete
                  v-model="stand.proprietario_id"
                  ref="proprietario"
                  :items="participantes"
                  label="Proprietário"
                  item-text="text"
                  item-value="id"
                  clearable
                  @keypress.native.enter="salvar"
                  :loading="carregando_participantes"
                  :disabled="proprietario_avulso"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.text"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.cidade_estado"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pa-3" v-else>
                <v-text-field
                  label="Proprietário Avulso"
                  ref="proprietario"
                  v-model="stand.avulso_nome"
                  @input="(value) => (stand.avulso_nome = value.toUpperCase())"
                  @keypress.native.enter="salvar"
                ></v-text-field>
              </v-col>
            </v-row>
            <span style="color: darkgray"
              ><b>*</b> Preenchimento obrigatório</span
            >
          </v-container>
        </v-form>
      </v-card>

      <v-layout v-show="loading" justify-center align-center mt-5>
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Services from "@/services/services.js";
import ServiceRodadas from "@/services/rodadas.js";

export default {
  name: "StandsForm",
  data() {
    return {
      loading: false,
      salvando: false,
      form_valid: false,
      stand: {
        id: "",
        nome: "",
        valor: "",
        proprietario_id: "",
        proprietario_tipo: "",
        avulso_nome: ""
      },
      regras: {
        nome: [(value) => !!value || "Campo Obrigatório"],
        valor: [
          (value) => !!value || "Campo obrigatório",
          (value) =>
            parseFloat(value.replace(",", ".")) > 0 ||
            "O valor não pode ser zero ou negativo",
        ],
      },
      proprietarios_tipo: [
        {
          text: "Avulso",
          value: "avulso",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        {
          text: "Fornecedor",
          value: "fornecedor",
        },
        {
          text: "Representante",
          value: "representante",
        },
      ],
      participantes: [],
      fornecedores: [],
      clientes: [],
      representantes: [],
      carregando_participantes: false,
      proprietario_avulso: false,
    };
  },
  mounted() {
    if (this.$route.params.stand_id) {
      this.editar();
    }
  },
  methods: {
    async editar() {
      try {
        this.loading = true;
        let response = await ServiceRodadas.editarStand(
          this.$route.params.rodada_id,
          this.$route.params.stand_id
        );

        this.stand = response.data.stand;

        if (response.data.proprietario_tipo == "fornecedor") {
          this.participantes = response.data.fornecedores;
        } else if (response.data.proprietario_tipo == "cliente") {
          this.participantes = response.data.clientes.map((cliente) => ({
            id: cliente.id,
            text: cliente.nome,
            cidade_estado: cliente.responsavel_nome,
          }));
        } else if (response.data.proprietario_tipo == "representante") {
          this.participantes = response.data.representantes;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async carregarParticipantes() {
      this.carregando_participantes = true;

      try {
        if (this.stand.proprietario_tipo == "cliente") {
          let response = await ServiceRodadas.carregarClientesRodada(
            this.$route.params.rodada_id
          );
          this.participantes = response.data.clientes.map((cliente) => ({
            id: cliente.id,
            text: cliente.nome,
            cidade_estado: cliente.responsavel_nome,
          }));
        } else if (this.stand.proprietario_tipo == "fornecedor") {
          let response = await ServiceRodadas.carregarFornecedoresRodada(
            this.$route.params.rodada_id
          );
          this.participantes = response.data.fornecedores;
        } else if (this.stand.proprietario_tipo == "representante") {
          let response = await ServiceRodadas.carregarRepresentantesRodada(
            this.$route.params.rodada_id
          );
          this.participantes = response.data.representantes;
        } else {
          this.participantes = [];
        }

        this.stand.proprietario_id = "";
      } catch (error) {
        console.log(error);
      } finally {
        this.carregando_participantes = false;
      }
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.salvando = true;
          if (this.stand.id) {
            await ServiceRodadas.atualizarStand(
              this.$route.params.rodada_id,
              this.$route.params.stand_id,
              this.stand
            );
            this.$eventbus.notificar("Stand atualizado com sucesso");
          } else {
            await ServiceRodadas.salvarStand(
              this.$route.params.rodada_id,
              this.stand
            );
            this.$eventbus.notificar("Stand salvo com sucesso");
          }
          this.$router.push(
            "/rodadas/" + this.$route.params.rodada_id + "/stands"
          );
        } catch (error) {
          console.log(error);
        } finally {
          this.salvando = false;
        }
      }
    },
  },
  watch: {
    'stand.proprietario_tipo': function (newVal, oldVal) {
      if (newVal == 'avulso') {
        this.proprietario_avulso = true;
        this.stand.proprietario_id = 0;
      } else {
        this.proprietario_avulso = false;
        this.stand.avulso_nome = "";
      }
    }
  }
};
</script>

<style></style>
